import axiosInstance from "./axiosService";
import serverUrl from "../config/serverUrl";

const API_URL = `${serverUrl}/admin`;

export const addProduct = async (data) => {
  try {
    const response = await axiosInstance.post(`${API_URL}/products`, data);
    return response.data;
  } catch (error) {
    console.log(error);
    throw error.response.data;
  }
};

export const deleteProduct = async (id) => {
  try {
    const response = await axiosInstance.delete(`${API_URL}/products/${id}`);
    return response.data;
  } catch (error) {
    console.log(error);
    throw error.response.data;
  }
};

export const createOffer = async (data) => {
  try {
    const response = await axiosInstance.post(`${API_URL}/offer`, data);
    return response.data;
  } catch (error) {
    console.log(error);
    throw error.response.data;
  }
};

export const getOffer = async () => {
  try {
    const response = await axiosInstance.get(`${API_URL}/offer`);
    return response.data;
  } catch (error) {
    console.log(error);
    throw error.response.data;
  }
};
